import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'

export const TagLabelWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
`
